module.exports = __webpack_public_path__ + "img/anon.0e8ec9a4.png";